export default [
  {
    path: '/',
    meta: {},
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/layouts/admin'),
    children: [
      {
        path: '/',
        name: 'landing',
        redirect: '/adm',
        component: () =>
          import(/* webpackChunkName: "landing" */ '../views/layouts/landing'),
        meta: {},
      },
      {
        path: 'verification/:token?',
        name: 'verification',
        component: () =>
          import(
            /* webpackChunkName: "landing" */ '../views/layouts/verification'
          ),
        meta: {},
      },
      {
        path: 'adm',
        name: 'admin',
        meta: {},
        redirect: '/adm/login',
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/layouts/main'),
        children: [
          {
            path: 'dashboard',
            name: 'adminDashboard',
            meta: {
              modulName: 'admin',
              pageName: 'dashboard',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-dashboard" */ '../views/admin/dashboard'
              ),
          },
          {
            path: 'pabrik',
            name: 'pabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pabrik" */ '../views/admin/pabrik'
              ),
          },
          {
            path: 'form-pabrik/:id?',
            name: 'formPabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-pabrik" */ '../views/admin/pabrik/form-pabrik'
              ),
          },
          {
            path: 'armada',
            name: 'armada',
            meta: {
              modulName: 'admin',
              pageName: 'armada',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-armada" */ '../views/admin/armada'
              ),
          },
          {
            path: 'form-armada/:id?',
            name: 'formArmada',
            meta: {
              modulName: 'admin',
              pageName: 'armada',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-armada" */ '../views/admin/armada/form-armada'
              ),
          },
          {
            path: 'distributor',
            name: 'distributor',
            meta: {
              modulName: 'admin',
              pageName: 'distributor',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-distributor" */ '../views/admin/distributor'
              ),
          },
          {
            path: 'form-distributor/:id?',
            name: 'formDistributor',
            meta: {
              modulName: 'admin',
              pageName: 'distributor',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-distributor" */ '../views/admin/distributor/form-distributor'
              ),
          },
          {
            path: 'materi',
            name: 'materi',
            meta: {
              modulName: 'admin',
              pageName: 'materi',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-materi" */ '../views/admin/materi'
              ),
          },
          {
            path: 'cost-category',
            name: 'kategori',
            meta: {
              modulName: 'admin',
              pageName: 'kategori',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-kategori" */ '../views/admin/kategori'
              ),
          },
          {
            path: 'pemasukan',
            name: 'pemasukan',
            meta: {
              modulName: 'admin',
              pageName: 'pemasukan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pemasukan" */ '../views/admin/pemasukan'
              ),
          },
          {
            path: 'print-pemasukan/:id_distributor?/:start_date?/:end_date?',
            name: 'printPengeluaran',
            meta: {
              modulName: 'admin',
              pageName: 'pemasukan',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-pemasukan" */ '../views/admin/pemasukan/print-report'
              ),
          },
          {
            path: 'pengeluaran',
            name: 'pengeluaran',
            meta: {
              modulName: 'admin',
              pageName: 'pengeluaran',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pengeluaran" */ '../views/admin/pengeluaran'
              ),
          },
          {
            path: 'print-pengeluaran/:id_distributor?/:start_date?/:end_date?',
            name: 'printPengeluaran',
            meta: {
              modulName: 'admin',
              pageName: 'pengeluaran',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-pengeluaran" */ '../views/admin/pengeluaran/print-report'
              ),
          },
          {
            path: 'customer',
            name: 'customer',
            meta: {
              modulName: 'admin',
              pageName: 'customer',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-customer" */ '../views/admin/customer'
              ),
          },
          {
            path:
              'print-customer/:id_distributor?/:province?/:cities?/:district?/:village?',
            name: 'printCustomer',
            meta: {
              modulName: 'admin',
              pageName: 'customer',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-customer" */ '../views/admin/customer/print-report'
              ),
          },
          {
            path: 'pegawai',
            name: 'pegawai',
            meta: {
              modulName: 'admin',
              pageName: 'pegawai',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pegawai" */ '../views/admin/employee'
              ),
          },
          {
            path: 'print-pegawai/:id_distributor?/:start_date?/:end_date?',
            name: 'printPegawai',
            meta: {
              modulName: 'admin',
              pageName: 'pegawai',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-pegawai" */ '../views/admin/employee/print-report'
              ),
          },
          {
            path: 'cara-bayar',
            name: 'carabayar',
            meta: {
              modulName: 'admin',
              pageName: 'caraBayar',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-carabayar" */ '../views/admin/cara-bayar'
              ),
          },
          {
            path: 'print-cara-bayar/:id_distributor?/:start_date?/:end_date?',
            name: 'printCustomer',
            meta: {
              modulName: 'admin',
              pageName: 'caraBayar',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-cara-bayar" */ '../views/admin/cara-bayar/print-report'
              ),
          },
          {
            path: 'product',
            name: 'product',
            meta: {
              modulName: 'admin',
              pageName: 'product',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-product" */ '../views/admin/product'
              ),
          },
          {
            path: 'form-product/:id?',
            name: 'formProduct',
            meta: {
              modulName: 'admin',
              pageName: 'product',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-product" */ '../views/admin/product/form-product'
              ),
          },
          {
            path: 'info',
            name: 'info',
            meta: {
              modulName: 'admin',
              pageName: 'info',
              pageType: 'view',
            },
            component: () =>
              import(/* webpackChunkName: "opr-info" */ '../views/admin/info'),
          },
          {
            path: 'form-info/:id?',
            name: 'formInfo',
            meta: {
              modulName: 'admin',
              pageName: 'info',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-info" */ '../views/admin/info/form-info'
              ),
          },
          {
            path: 'promotion',
            name: 'promotion',
            meta: {
              modulName: 'admin',
              pageName: 'promotion',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-promotion" */ '../views/admin/promotion'
              ),
          },
          {
            path: 'form-promotion/:id?',
            name: 'formPromotion',
            meta: {
              modulName: 'admin',
              pageName: 'promotion',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-promotion" */ '../views/admin/promotion/form-promotion'
              ),
          },
          {
            path: 'administrator',
            name: 'administrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-administrator" */ '../views/admin/administrator'
              ),
          },
          {
            path: 'form-administrator/:id?',
            name: 'formAdministrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-administrator" */ '../views/admin/administrator/form-administrator'
              ),
          },
          {
            path: 'laporan',
            name: 'laporan',
            meta: {
              modulName: 'admin',
              pageName: 'laporan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-laporan" */ '../views/admin/laporan'
              ),
          },
          {
            path:
              'print-laporan/:id_distributor?/:id_product?/:start_date?/:end_date?/:type?',
            name: 'printLaporan',
            meta: {
              modulName: 'admin',
              pageName: 'laporan',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-laporan" */ '../views/admin/laporan/print-report'
              ),
          },
          {
            path: 'sales',
            name: 'sales',
            meta: {
              modulName: 'admin',
              pageName: 'sales',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-sales" */ '../views/admin/sales'
              ),
          },
          {
            path: 'print-sales/:id_distributor?/:start_date?/:end_date?',
            name: 'printSales',
            meta: {
              modulName: 'admin',
              pageName: 'sales',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-sales" */ '../views/admin/sales/print-report'
              ),
          },
          {
            path: 'print-detail-sales/:id?',
            name: 'printDetailSales',
            meta: {
              modulName: 'admin',
              pageName: 'sales',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-sales" */ '../views/admin/sales/print-detail'
              ),
          },
          {
            path: 'form-sales/:id?',
            name: 'formsales',
            meta: {
              modulName: 'admin',
              pageName: 'sales',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-sales" */ '../views/admin/sales/form-sales'
              ),
          },
          {
            path: 'purchase-gold',
            name: 'purchaseGold',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseGold',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-purchase-gold" */ '../views/admin/purchase-gold'
              ),
          },
          {
            path:
              'print-purchase-gold/:id_distributor?/:start_date?/:end_date?',
            name: 'printPurchase',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseGold',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase-gold" */ '../views/admin/purchase-gold/print-report'
              ),
          },
          {
            path: 'print-detail-purchase-gold/:id?',
            name: 'printDetailPurchaseGold',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseGold',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase-gold" */ '../views/admin/purchase-gold/print-detail'
              ),
          },
          {
            path: 'form-purchase-gold/:id?',
            name: 'formPurchaseGold',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseGold',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-purchase-gold" */ '../views/admin/purchase-gold/form-purchase'
              ),
          },
          {
            path: 'purchase',
            name: 'purchase',
            meta: {
              modulName: 'admin',
              pageName: 'purchase',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-purchase" */ '../views/admin/purchase'
              ),
          },
          {
            path: 'print-purchase/:id_distributor?/:start_date?/:end_date?',
            name: 'printPurchase',
            meta: {
              modulName: 'admin',
              pageName: 'purchase',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase" */ '../views/admin/purchase/print-report'
              ),
          },
          {
            path: 'print-detail-purchase/:id?',
            name: 'printDetailPurchase',
            meta: {
              modulName: 'admin',
              pageName: 'purchase',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase" */ '../views/admin/purchase/print-detail'
              ),
          },
          {
            path: 'form-purchase/:id?',
            name: 'formPurchase',
            meta: {
              modulName: 'admin',
              pageName: 'purchase',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-purchase" */ '../views/admin/purchase/form-purchase'
              ),
          },
          {
            path: 'purchase-delivery',
            name: 'purchaseDelivery',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseDelivery',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-purchase-delivery" */ '../views/admin/purchase-delivery'
              ),
          },
          {
            path:
              'print-purchase-delivery/:id_distributor?/:start_date?/:end_date?/:tgl_kirim?/:id_armada?/:kloter?/:report_type?',
            name: 'printPurchaseDelivery',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseDelivery',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase" */ '../views/admin/purchase-delivery/print-report'
              ),
          },
          {
            path: 'print-detail-purchase-delivery/:id?',
            name: 'printDetailPurchaseDelivery',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseDelivery',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase" */ '../views/admin/purchase-delivery/print-detail'
              ),
          },
          {
            path: 'print-detail-purchase-do/:id?',
            name: 'printDetailPurchaseDeliveryDo',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseDelivery',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-purchase" */ '../views/admin/purchase-delivery/print-do'
              ),
          },
          {
            path: 'form-purchase-delivery/:id?',
            name: 'formPurchaseDelivery',
            meta: {
              modulName: 'admin',
              pageName: 'purchaseDelivery',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-purchase" */ '../views/admin/purchase-delivery/form-purchase'
              ),
          },
          {
            path: 'login',
            name: 'login',
            component: () =>
              import(/* webpackChunkName: "login" */ '../views/account/login'),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: () =>
              import(
                /* webpackChunkName: "forgot" */ '../views/account/forgot-password'
              ),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'profile',
            name: 'ProfileAdmin',
            component: () =>
              import(
                /* webpackChunkName: "profile-admin" */ '../views/account/profile'
              ),
            meta: {},
          },
        ],
      },
      // {
      //   path: '/usr',
      //   name: 'user',
      //   meta: {},
      //   component: () =>
      //     import(/* webpackChunkName: "user" */ '../views/layouts/user'),
      //   redirect: '/',
      //   children: [
      //     {
      //       path: 'dashboard',
      //       name: 'userDashboard',
      //       meta: {},
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "user-dashboard" */ '../views/user/user-dashboard'
      //         ),
      //       children: [],
      //     },
      //   ],
      // },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "forgot" */ '../views/layouts/notfound'),
  },
];
